import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Shared Lists';

export const SharedRoutes = [
  {
    path: '/shared',
    name: 'Shared Program',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/SharedProgram.vue'),
    children: [
      {
        path: 'banks',
        name: 'Shared Program - Banks',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/Banks.vue'),
      },
      {
        path: 'funds',
        name: 'Shared Program - Funds',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/Funds.vue'),
      },
      {
        path: 'source',
        name: 'Shared Program - Sources',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/Source.vue'),
      },
      {
        path: 'taxmortgagecodes',
        name: 'Shared Program - Tax Mortgage Codes',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxMortgageCodes.vue'),
      },
      {
        path: 'taxstatuscodes',
        name: 'Shared Program - Tax Status Codes',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxStatusCodes.vue'),
      },
      {
        path: 'taxfeetypes',
        name: 'Shared Program - Tax Fees',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxFeeTypes.vue'),
      },
      {
        path: 'taxadjtypes',
        name: 'Shared Program - Tax ADJ Types',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxAdjTypes.vue'),
      },
      {
        path: 'taxCommentTypes',
        name: 'Shared Program - Tax Comment Types',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxCommentTypes.vue'),
      },
      {
        path: 'taxReasonCode',
        name: 'Shared Program - Reason Codes',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxReasonCode.vue'),
      },
      {
        path: 'taxadditions',
        name: 'Shared Program - Tax Additions',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxAdditions.vue'),
      },
      {
        path: 'taxstreets',
        name: 'Shared Program - Tax Streets',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxStreets.vue'),
      },
      {
        path: 'taxLevy',
        name: 'Shared Program - Tax Levy',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxLevy.vue'),
      },
      {
        path: 'taxUnit',
        name: 'Shared Program - Tax Unit',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxUnit.vue'),
      },
      {
        path: 'remitUnit',
        name: 'Shared Program - remit Unit',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/remitUnit.vue'),
      },
      {
        path: 'taxDistrict',
        name: 'Shared Program - Tax Districts',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxDistrict.vue'),
      },
      {
        path: 'taxFund',
        name: 'Shared Program - Tax Fund',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxFund.vue'),
      },
      {
        path: 'taxrollsummary',
        name: 'Shared Program - Tax Roll Summary',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/shared/taxRollSummary.vue'),
      },
      {
        path: 'dropdowns',
        name: 'Shared Program - Drop Downs',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../components/shared/DropDowns.vue'),
      },
    ],
  },
];

SharedRoutes.forEach((element, index) => {
  SharedRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria(authRoles.shared.SharedProgram, next);
  };
});

export default SharedRoutes;
